import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { t } from "@/i18n-js/instance";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Typography } from "@circle-react-uikit/Typography";
import { IconButton } from "../../uikit/HeaderV3/IconButton";
import { BlockPreviewList } from "../BlockList/BlockPreviewList";
import { SidebarHeader } from "../Sidebar/SidebarHeader";
import { SidebarHeaderTitle } from "../Sidebar/SidebarHeaderTitle";
import { useCategorizedElementsList } from "./useCategorizedElementsList";

interface ElementsListProps {
  allowClose?: boolean;
}
export const ElementsList = ({ allowClose = true }: ElementsListProps) => {
  const { blocks, closeSidebarView } = useBuilderStore(state => ({
    blocks: state.blockMapping,
    closeSidebarView: state.closeSidebarView,
  }));

  const categorizedBlocks = useCategorizedElementsList({
    blocks,
  });

  return (
    <div className="divide-primary flex h-full w-[20.5rem] flex-col divide-y">
      <SidebarHeader>
        <div className="flex w-full items-center justify-between">
          <SidebarHeaderTitle>
            {t("builder_ui.elements_list.add_elements")}
          </SidebarHeaderTitle>
          {allowClose && (
            <IconButton
              name="24-close"
              iconSize={24}
              ariaLabel={t("close")}
              onClick={closeSidebarView}
            />
          )}
        </div>
      </SidebarHeader>
      <div className="flex size-full flex-col overflow-hidden">
        <OverlayScrollbarsComponent>
          {categorizedBlocks.map(category => (
            <div key={category.name} className="flex flex-col gap-2 px-5 py-3">
              <div className="flex items-baseline gap-1">
                <Typography.LabelXs color="text-tertiary" weight="semibold">
                  {category.nameI18n ? t(category.nameI18n) : category.name}
                </Typography.LabelXs>
                {category.tooltipDescriptionI18n && (
                  <TippyV2
                    content={t(category.tooltipDescriptionI18n)}
                    placement="right"
                    arrow={false}
                    delay={[200, 0]}
                  >
                    <Icon
                      type="16-info"
                      size={16}
                      className="text-tertiary cursor-pointer"
                      aria-label={t("builder_ui.elements_list.info")}
                    />
                  </TippyV2>
                )}
              </div>
              <BlockPreviewList isElementType blocks={category.blocks} />
            </div>
          ))}
        </OverlayScrollbarsComponent>
      </div>
    </div>
  );
};
